// import FormField to handle MSN input changes and form submission.
import useMsnSearch from "../../hooks/useMsnSearch";
import ErrorBoundary from "../layout/ErrorBoundary";
import FormField from "../layout/FormField";

import MeterDetailsView from "./MeterDetailsView";

const MsnSearch: React.FC = () => {
  const {
    msnInput,
    setMsnInput,
    postcodeInput,
    setPostcodeInput,
    isValidSearch,
    error,
    isLoading,
    meterDetails,
    handleSearch,
  } = useMsnSearch();

  return (
    <div className="search-form">
      {/* Render the form fields to allow the user to enter MSN and postcode and trigger a search on submit. */}
      <FormField
        inputFields={[
          {
            id: "msn",
            placeholder: "Enter a MSN",
            value: msnInput,
            onChange: setMsnInput,
          },
          {
            id: "postcode",
            placeholder: "Enter a postcode",
            value: postcodeInput,
            onChange: setPostcodeInput,
          },
        ]}
        onSubmit={handleSearch}
        disabled={isLoading}
        testIdPrefix="electralink-msn"
      />

      {/* In case of an error, display the error message on the UI. */}
      {error && (
        <div className="error-message" data-testid="electralink-msn-error">
          {error}
        </div>
      )}
      {/* Display a 'loading' indicator to provide UI feedback to users as they await the API response. */}
      {isLoading && (
        <div className="electralink-loading-message" data-testid="electralink-msn-loading">
          Loading...
        </div>
      )}

      {/* If the search is valid, display confirmation message. */}
      {isValidSearch && !isLoading && (
        <div className="mpan-validation-status" data-testid="electralink-msn-valid">
          <div className="mpan-status">
            <span className="valid-mpan-circle"></span>
            <span className="mpan-text">Valid MSN & Postcode</span>
          </div>
        </div>
      )}

      {/* Display meter details if the MSN search was successful. */}
      <ErrorBoundary level="section" label="these results" resetKey={meterDetails}>
        {meterDetails && <MeterDetailsView meterDetails={meterDetails} />}
      </ErrorBoundary>
    </div>
  );
};

export default MsnSearch;
